export const SET_MAP_GEOHASHES = 'SET_MAP_GEOHASHES';
export const SET_MAP_CENTER = 'SET_MAP_CENTER';
export const SET_MAP_ZOOM = 'SET_MAP_ZOOM';
